import {createGlobalState} from 'react-hooks-global-state';
const DEFAULT_THEME = {
    primary: {
        main: '#ff5722'
    },
    secondary: {
        main: '#ff5722'
    }
};
const initialState = {
    user: {}, theme: DEFAULT_THEME, confirmationDialogs: [], currentDialogAppBarWidth: 0,  drawer_info: false, toolbar: true, title: "Sign Tool"
};
let {GlobalStateProvider, useGlobalState} = createGlobalState(initialState);

let useCurrentState = useGlobalState;
export {GlobalStateProvider, DEFAULT_THEME, useCurrentState};